import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { CategoryListComponent } from './category-list.component'
import { SharedModule } from '../../shared/shared.module'
import { SlimHeaderModule } from '../slim-header/slim-header.module'
import { AvatarModule } from '../avatar/avatar.module'
import { ElementIsVisibleModule } from '../element-is-visible/element-is-visible.module'
import { ErrorModule } from '../error/error.module'
import { NoResultsModule } from '../no-results/no-results.module'
import { AdhesionFooterModule } from '../adhesion-footer/adhesion-footer.module'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    SlimHeaderModule,
    NoResultsModule,
    AvatarModule,
    ElementIsVisibleModule,
    ErrorModule,
    AdhesionFooterModule
  ],
  declarations: [CategoryListComponent],
  exports: [CategoryListComponent]
})
export class CategoryListModule {}
